import { render, staticRenderFns } from "./Bids.vue?vue&type=template&id=33f6339c&scoped=true&"
import script from "./Bids.vue?vue&type=script&lang=js&"
export * from "./Bids.vue?vue&type=script&lang=js&"
import style0 from "./Bids.vue?vue&type=style&index=0&id=33f6339c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6339c",
  null
  
)

export default component.exports